import { OBJECT_TYPES } from "appConstants";

export const SETTINGS = [
  {
    apiName: "returnToVendorNumber",
    component: "FrmTransactionNumber",
    transactionType: OBJECT_TYPES.RETURN_TO_VENDOR.fullString,
    hasInputLabel: true,
  },
];
